import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'

export const useSportsStore = defineStore('sportsStore', () => {
    const fetcher = useCustomFetch()

    // o-sport: v1/athena/sportUrl
    // s-sport: v1/tp/ssportUrl
    // k-sport: v1/tp/ksportUrl
    // t-sport: v1/tp/tsportUrl
    const sportUrl = ref('')

    const getSportUrl = async (sportApi) => {
        try {
            const { data } = await fetcher.get(sportApi)
            // if (data.value?.status === STATUS_OK) {
            //     sportUrl.value = data.value?.data?.url
            // }
            return { data: data.value }
        } catch (error) {
            console.log('sportsStore', error)
        }
    }

    const restSportUrl = () => {
        sportUrl.value = ''
    }

    const sportItems = ref([
        // BTI
        {
            id: 'bti',
            key: 'bti',
            title: 'bti',
            api_url: '/gameUrl?partnerProvider=bti',
            page_url: '/btisports',
            logo: '/assets/icons/casino/provider/a-sport.svg',
            image: '/assets/img/sports/sportbook/bti-card.png',
            imageMobile: '/assets/img/sports/sportbook/bti-mb.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: true,
        },
        // SABA
        {
            id: 'saba',
            key: 'saba',
            title: 'saba',
            api_url: '/athena/sportUrl',
            page_url: '/saba-sports',
            logo: '/assets/icons/casino/provider/t-sport.svg',
            image: '/assets/img/sports/sportbook/saba-card.png',
            imageMobile: '/assets/img/sports/sportbook/saba-mb.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: false,
        },
        // K-SPORT
        {
            id: 'ksport',
            title: 'sport',
            key: 'ksport',
            api_url: '/tp/ksportUrl',
            page_url: '/ksports',
            logo: '/assets/icons/casino/provider/k-sport.svg',
            image: '/assets/img/sports/sportbook/ksport-card.png',
            imageMobile: '/assets/img/sports/sportbook/ksport-mb.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: false,
        },
    ])
    const sportVirtualItems = ref([
        // SABA VIRTUAL
        {
            id: 'saba',
            key: 'saba',
            title: 'saba',
            api_url: '/athena/virtualSportUrl?loginPath=saba-sports?login=true',
            page_url: '/saba-sports?virtualsport=true',
            logo: '/assets/icons/casino/provider/saba.svg',
            image: '/assets/img/sports/virtualsport/saba-card.png',
            imageMobile: '/assets/img/sports/virtualsport/saba-mb.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
        },
        // IN PLAY VIRTUAL
        {
            id: 'in_play',
            key: 'in_play',
            title: 'In play',
            api_url: '/gameUrl?p=im&gId=virtualsport',
            page_url: '/in-play',
            logo: '/assets/icons/casino/provider/in_play.png',
            image: '/assets/img/sports/virtualsport/inplay-card.png',
            imageMobile: '/assets/img/sports/virtualsport/inplay-mb.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
        },
        // KSPORT VIRTUAL
        {
            id: 'ksport',
            key: 'ksport',
            title: 'Ksport',
            api_url: '/tp/ksportUrl?isvirtual=true',
            page_url: '/ksports?isvirtual=true',
            logo: '/assets/icons/casino/provider/k-sport.svg',
            image: '/assets/img/sports/virtualsport/ksport-card.png',
            imageMobile: '/assets/img/sports/virtualsport/ksport-mb.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
        },
        // BETRADAR
        {
            id: 'betradar',
            key: 'betradar',
            title: 'Betradar',
            api_url: 'gameUrl?partnerProvider=betradar&partnerGameId=vfb',
            page_url: '/betradar-sports',
            logo: '/assets/icons/casino/provider/s-sport.svg',
            image: '/assets/img/sports/virtualsport/betradar-card.png',
            imageMobile: '/assets/img/sports/virtualsport/betradar-mb.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
        },
    ])
    const apiarr = ref()
    const { execute } = useApi('/provider', {
        immediate: false,
        onResponse({ response }) {
            if (response._data?.status === 'OK') {
                apiarr.value = response._data.data
                return response._data.data
            }
        },
    })
    const intersectionSportBookItems = computed(() => {
        if (!apiarr.value) return []
        return apiarr.value.sport.map((obj1) => ({
            ...sportItems.value.find((obj2) => obj2.key === obj1.key),
            ...obj1,
        }))
    })
    const intersectionSportVirtualItems = computed(() => {
        if (!apiarr.value) return []
        return apiarr.value.virtual_sport?.map((obj1) => ({
            ...sportVirtualItems.value.find((obj2) => obj2.key === obj1.key),
            ...obj1,
        }))
    })

    return {
        sportUrl,
        getSportUrl,
        restSportUrl,
        intersectionSportBookItems,
        intersectionSportVirtualItems,
        execute,
    }
})
